import { NavigationItem } from "../../../core/navigation/types";
import OrderIndPage from "./OrderIndPage";
import { EditOrderIndPage } from "./EditOrderIndPage";
import { orderIndLocation, editRouter } from "./Locations";
export const orderIndComponents: NavigationItem[] = [
	{
		Component: OrderIndPage,
		isMenuItem: true,
		path: orderIndLocation,
	},
	{
		Component: EditOrderIndPage,
		isMenuItem: false,
		path: editRouter,
	},
];
